import { render, staticRenderFns } from "./LoadingEllipsis.vue?vue&type=template&id=4ceeffb6&scoped=true&"
import script from "./LoadingEllipsis.vue?vue&type=script&lang=ts&"
export * from "./LoadingEllipsis.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingEllipsis.vue?vue&type=style&index=0&id=4ceeffb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceeffb6",
  null
  
)

export default component.exports